import React from 'react';
import {mainGreen} from 'styles/variables';

export default function CheckSuccess({height = 20, width = 20, ...rest}) {
    return (
        <svg width={width} height={height} viewBox='0 0 20 20' {...rest}>
            <g fill='none' fillRule='nonzero'>
                <path fill={mainGreen} d='M10 16.47a6.47 6.47 0 1 0 0-12.94 6.47 6.47 0 0 0 0 12.94z' />
                <path fill='#FFF' d='M9.293 11.25l3.785-3.727.673.663-4.458 4.389-2.698-2.656.673-.663z' />
            </g>
        </svg>
    );
}
